import { useUser } from "auth";
import { useEffect } from "react";
import { Redirect, useHistory, useLocation } from "react-router";

export const LoginWithNonce = () => {
  const { login } = useUser();
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const nnc = params.get("nnc");

  useEffect(() => {
    if (nnc != null) {
      login({ nonce: nnc }).then(() => {
        history.push("/");
      });
    }
  }, [nnc, history, login]);

  return nnc == null ? <Redirect to="/" /> : null;
};
